export default __webpack_public_path__ + "static/media/hero_logo_white.5a042cbd.png";